export default __webpack_public_path__ + "static/media/actividad-25.cc720bc2.mp3";